import { create } from "zustand";
import { createAsyncFetcher } from "./Utilities/Fetch/createAsyncFetcher";
import { fetchLogin } from "./Services/fetchlogin";
import {
  getVentasMensuales,
  getAcumuladoVentas,
  getPeriodosVentas,
  getVendedores
} from "./Services/fetchVentas";
import {
  getVendedoresComisiones,
  postComisionesComercialAnualMensual
} from "./Services/fetchComisiones";
import { getOrdenesResumen } from "./Services/apiOrdenes";
import { getDisponibilidadOrden } from "./Services/getDisponibilidadOrden";
import { buscarProductoPorCodigo } from "./Services/fetchProductosStore";
import { obtenerTodosLosProductos } from "./Services/fetchProductos";
import { getOperadorInyeccion } from "./Services/fetchInyeccion";
import { fetchRegistrarEmpresa } from "./Services/etchRegistrarEmpresa";
import { fetchGetEmpresasRegistros } from "./Services/fetchGetEmpresasRegistros";

const useStore = create((set) => ({
  loading: false,
  error: null,
  users: [],
  ventasMensuales: [],
  acumuladoVentas: null,
  periodosVentas: [],
  comisionVendedores: [],
  comisionesData: null,
  ordenesResumen: [],
  disponibilidadOrden: [],
  productoBuscado: null,
  productosTotales: [],
  operadorInyeccion: [],
  empresaRegistrada: null,
  empresasRegistros: null,

  // — Reset de error —
  resetError: () => set({ error: null }),

  // — Login (sin asignar data) —
  fetchDataLogin: async (body) => {
    set({ loading: true, error: null });
    try {
      await fetchLogin(body);
    } catch (err) {
      set({ error: err instanceof Error ? err.message : String(err) });
    } finally {
      set({ loading: false });
    }
  },

  // — Fetchers simplificados —
  fetchVendedores: createAsyncFetcher(getVendedores, "users", set),

  fetchVentasMensuales: createAsyncFetcher(
    ({ anio, gId, eId }) => getVentasMensuales(anio, gId, eId),
    "ventasMensuales",
    set
  ),

  fetchAcumuladoVentas: createAsyncFetcher(
    ({ anio, gId, eId }) => getAcumuladoVentas(anio, gId, eId),
    "acumuladoVentas",
    set
  ),

  fetchPeriodosVentas: createAsyncFetcher(
    ({ anio, numMes1, numMes2, gId, eId }) =>
      getPeriodosVentas(anio, numMes1, numMes2, gId, eId),
    "periodosVentas",
    set
  ),

  fetchComisionVendedores: createAsyncFetcher(
    getVendedoresComisiones,
    "comisionVendedores",
    set
  ),

  fetchComisiones: createAsyncFetcher(
    ({ comercial_id, anio, fechaInicio, fechaFin }) =>
      postComisionesComercialAnualMensual({
        comercial_id,
        anio,
        fechaInicio,
        fechaFin,
      }),
    "comisionesData",
    set
  ),

  fetchOrdenesResumen: createAsyncFetcher(
    getOrdenesResumen,
    "ordenesResumen",
    set
  ),

  fetchDisponibilidadPorOrden: createAsyncFetcher(
    async (ordenId) => {
      const { code, data } = await getDisponibilidadOrden(ordenId);
      if (code === 200 && !data.error) {
        return { code: 200, data: data.resultados };
      } else {
        throw new Error(data.message || "No se pudo obtener la disponibilidad");
      }
    },
    "disponibilidadOrden",
    set
  ),

  fetchProductoPorCodigo: createAsyncFetcher(
    buscarProductoPorCodigo,
    "productoBuscado",
    set
  ),

  fetchTodosLosProductos: createAsyncFetcher(
    obtenerTodosLosProductos,
    "productosTotales",
    set
  ),

  fetchOperadorInyeccion: createAsyncFetcher(
    getOperadorInyeccion,
    "operadorInyeccion",
    set
  ),

  fetchRegistrarEmpresa: async (body) => {
    set({ loading: true, error: null });
    try {
      await fetchRegistrarEmpresa(body);
    } catch (err) {
      set({ error: err instanceof Error ? err.message : String(err) });
    } finally {
      set({ loading: false });
    }
  },
  fetchGetEmpresasRegistros: createAsyncFetcher(
    fetchGetEmpresasRegistros,
    "empresasRegistros",
    set
  ),
}));

export default useStore;